export default __webpack_public_path__ + "static/preview-9b179dd449eb692aa45626c7129c2112.jpg";